/* === Ala gift-ladder tier 3 (D-096, 2026-07-09) ===
 *
 * Free CloudSoft Short Sleeve when the cart holds >= $150 of paid merchandise.
 * Hydrates the [data-ala-tier3] snippet rendered in the cart drawer + /cart
 * page (snippets/ala-tier3-gift.liquid). Server-side enforcement is the
 * tier3-free-cloudsoft Shopify Function — this JS and that Function MUST use
 * the threshold rule: merchandise total (post-discount for known cookie
 * codes since D-119; server Function enforces true post-discount), gift line
 * excluded (AQ-5 $0 gift lines contribute $0 naturally).
 *
 * DORMANT until window.ALA_TIER3_ENABLED = true (theme.liquid) — flip at the
 * Jul-17 cutover. Pre-launch testing: visit any page with ?ala-tier3-preview
 * (sticky for the session via sessionStorage).
 *
 * Patterns inherited from aq5-cart-optin.js: document-level delegation +
 * MutationObserver re-hydration (Maestrostack <m-cart-items> innerHTML
 * re-renders discard per-element listeners), data-index bridge for tagging
 * the gift row (D-052), cart:refresh/cart:updated dispatch after mutations.
 */
(function () {
  'use strict';

  var PREVIEW_KEY = 'ala_tier3_preview';
  var enabled = window.ALA_TIER3_ENABLED === true;
  try {
    if (new URL(location.href).searchParams.has('ala-tier3-preview')) {
      sessionStorage.setItem(PREVIEW_KEY, '1');
    }
    if (sessionStorage.getItem(PREVIEW_KEY) === '1') enabled = true;
  } catch (e) { /* swallow */ }
  if (!enabled) return;

  var THRESHOLD_CENTS = 15000;
  // D-149 one-milestone rule: below the $100 free-US-shipping goal the FoxKit
  // cart-goal bar is the ONLY push; this band renders nothing.
  // D-151: the milestone is code-raised in computeState (see the D-119 note
  // there) and syncGoalBarTitle() keeps the FoxKit copy truthful — checkout
  // grants free ship on the POST-discount subtotal, so $100 gross is NOT the
  // earn point for code-holders ($133.34 gross under ALA25). For the no-code
  // path FoxKit + Shopify's rate table remain the untouched source of truth.
  var SHIP_MILESTONE_CENTS = 10000;
  var GIFT_HANDLE = 'free-cloudsoft-short-sleeve-150-gift'; // $0 gift product (D-097)
  var GIFT_PRODUCT_ID = 10408209187095;
  var GIFT_PROP = '_ala_tier3_gift';

  var productData = null;   // { colors: [..], variantsByColor: {color: [{id,size,available}]} }
  var productFetchP = null;
  var lastState = null;     // cached render state for instant re-hydration
  var lastCart = null;      // cached /cart.js payload (D-150 bridge needs items)
  var actionInFlight = false;

  // D-119: highest known percentage among codes in Shopify's discount_code
  // cookie (set by /discount/CODE links). Mirrors discount-aware-pricing.js's
  // cookie read; knownDiscounts comes from ALA_DISCOUNT_CONFIG in theme.liquid.
  // D-193 (2026-10-06): once a code ATTACHES to the cart, Shopify no longer
  // keeps the discount_code cookie (measured: cart.js discount_codes =
  // [{code:'FALL30',applicable:true}] with NO cookie). Cookie-only reading made
  // codePct 0, so the bridge treated a net gap as gross and labelled a $64 top
  // "This closes it" when it nets $44.80 under FALL30. Read applicable cart
  // codes too; the cookie still covers the set-but-unattached window.
  function knownCookieCodePct(cart) { return knownCookieCode(cart).pct; }
  // D-248: the same read, also naming the code that set the pct (the bridge chip
  // needs it: a discountable-only code does not reach a clearance product).
  function knownCookieCode(cart) {
    try {
      var known = (window.ALA_DISCOUNT_CONFIG && window.ALA_DISCOUNT_CONFIG.knownDiscounts) || {};
      var upper = {};
      Object.keys(known).forEach(function (k) { upper[k.toUpperCase()] = known[k]; });
      var codes = [];
      var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
      if (m) codes = codes.concat(decodeURIComponent(m[1]).split(','));
      ((cart && cart.discount_codes) || []).forEach(function (d) { if (d && d.applicable && d.code) codes.push(d.code); });
      var pct = 0, code = null;
      codes.forEach(function (c) {
        var p = upper[String(c).trim().toUpperCase()] || 0;
        if (p > pct) { pct = p; code = String(c).trim(); }
      });
      return { code: code, pct: pct };
    } catch (e) { return { code: null, pct: 0 }; }
  }
  // D-248: does the active code reach this product at checkout? Codes listed in
  // ALA_DISCOUNT_CONFIG.discountableOnlyCodes reach only discountableHandles.
  function codeReachesHandle(code, handle) {
    var cfg = window.ALA_DISCOUNT_CONFIG || {};
    var only = (cfg.discountableOnlyCodes || []).map(function (c) { return String(c).toUpperCase(); });
    if (!code || only.indexOf(String(code).toUpperCase()) === -1) return true;
    var handles = (cfg.discountableHandles || []).map(function (h) { return String(h).toLowerCase(); });
    return handles.indexOf(String(handle).toLowerCase()) !== -1;
  }
  var refreshTimer = null;

  function fetchProduct() {
    if (productFetchP) return productFetchP;
    productFetchP = fetch('/products/' + GIFT_HANDLE + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var colors = [];
        var byColor = {};
        var imgByColor = {};
        (p.variants || []).forEach(function (v) {
          var color = v.option1;
          var size = v.option2;
          if (!byColor[color]) { byColor[color] = []; colors.push(color); }
          byColor[color].push({ id: v.id, size: size, available: !!v.available });
          if (!imgByColor[color] && v.featured_image && v.featured_image.src) {
            imgByColor[color] = v.featured_image.src;
          }
        });
        // D-154 (panel B-1): a fully-OOS or empty gift catalog must fail
        // CLOSED — truthy-but-empty productData would render a dead picker at
        // >=$150 while the goal bar is hidden (no voice, inert Add).
        var anyAvailable = colors.some(function (c) {
          return (byColor[c] || []).some(function (v) { return v.available; });
        });
        productData = anyAvailable ? { colors: colors, byColor: byColor, imgByColor: imgByColor } : null;
        return productData;
      })
      .catch(function () { productData = null; productFetchP = null; });
    return productFetchP;
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function isGiftItem(it) {
    // The $0 gift product only ever enters carts through this module, so the
    // handle alone identifies it (property kept on add for order traceability).
    return it.handle === GIFT_HANDLE;
  }

  function money(cents, currency) {
    var d = cents / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD',
        minimumFractionDigits: d % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2,
      }).format(d);
    } catch (e) {
      return d % 1 === 0 ? '$' + d : '$' + d.toFixed(2);
    }
  }

  // --------- state computation ---------

  // D-097: the gift is a real $0-priced product — no discount is involved, so
  // discount codes (ALA25 etc.) coexist natively and code-holders see the band
  // like everyone else. Server-side enforcement = the tier3-gift-validation
  // checkout Function (blocks checkout if gift present under $150 or qty > 1).
  function computeState(cart) {
    var items = cart.items || [];
    var giftLines = [];
    var qualifying = 0;
    var shipQualifying = 0;
    var qualifyingNet = 0;
    var shipQualifyingNet = 0;
    var paidItemCount = 0;
    var countedLines = []; // D-249: what each counted line is, so a code's reach can be measured per line
    items.forEach(function (it) {
      if (isGiftItem(it)) {
        giftLines.push(it);
        return;
      }
      // A36 #3: the welcome popup's free Claw Clip (made $0 by the welcome-claw-clip Function) never counts toward
      // free shipping or the $150 gift.
      if (it.properties && (it.properties._ala_welcome_gift === 'true' || it.properties._ala_shiftset_gift === 'true')) return;   // + D-209 Shift Set gift
      var lineGross = it.original_line_price != null ? it.original_line_price : (it.price * it.quantity);
      // D-159: cart-level codes (and automatic/scoped discounts) now apply ON
      // the cart object — final_line_price is the POST-discount line total
      // (live-proven 2026-08-19). Sum it alongside gross; when they differ the
      // cart itself is the net ground truth (any discount shape, no map).
      var lineNet = it.final_line_price != null ? it.final_line_price : lineGross;
      qualifying += lineGross;
      qualifyingNet += lineNet;
      countedLines.push({ handle: it.handle, gross: lineGross, ship: it.requires_shipping !== false });
      // D-152: the $0-rate's TOTAL_PRICE condition counts SHIPPABLE merchandise
      // only (live-proven: $100 gift card + $38 top -> $8.95 charged), so the
      // ship milestone measures shippable lines only. Gift cards still count
      // toward the $150 gift (qualifying) — the checkout Function sums all
      // lines. Missing field defaults to shippable.
      if (it.requires_shipping !== false) { shipQualifying += lineGross; shipQualifyingNet += lineNet; }
      if (it.price > 0) paidItemCount += it.quantity;
    });
    var giftUnits = giftLines.reduce(function (s, l) { return s + l.quantity; }, 0);
    // Currency handling (D-100, upgrades the D-099 hide-guard): cart.js prices
    // are PRESENTMENT currency — Managed Markets converts for international
    // visitors (e.g. DOP). Convert the $150 threshold into the presentment
    // currency via Shopify.currency.rate so international shoppers see the
    // goal with correct math (server-side tier3-gift-validation does the
    // mirror-image division by presentmentCurrencyRate). If the rate is
    // unavailable for a non-USD cart we can't trust the math — hide the band.
    var currency = cart.currency || 'USD';
    var rate = 1;
    if (currency !== 'USD') {
      rate = parseFloat((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || '0') || 0;
    }
    var convertible = currency === 'USD' || rate > 0;
    var thresholdCents = convertible ? Math.round(THRESHOLD_CENTS * rate) : Infinity;
    // D-119 (2026-07-20): the checkout Function now enforces the $150 on the
    // POST-discount total. If a known discount cookie is active (/discount/
    // links — e.g. ALA25 from the abandoned flow), raise the band's threshold
    // so we never invite a gift the checkout will refuse: at pct off, a cart
    // needs THRESHOLD/(1-pct) gross to still be $150 after the code. Codes
    // typed manually at checkout stay invisible here — the Function catches
    // those with its own error message.
    var codeInfo = knownCookieCode(cart);
    var codePct = codeInfo.pct;
    var shipGoalNetCents = convertible ? Math.round(SHIP_MILESTONE_CENTS * rate) : Infinity;
    var shipMilestoneCents = shipGoalNetCents;
    if (codePct > 0 && codePct < 1) {
      thresholdCents = Math.round(thresholdCents / (1 - codePct));
      // D-151 (2026-08-19): same raise for the free-ship milestone. The $0
      // Standard rate's TOTAL_PRICE >= $100 condition reads the POST-discount
      // subtotal (live-verified: gross $100/net $75 w/ ALA25 -> $8.95 charged;
      // gross $162/net $121.50 -> FREE), so a code-holder needs SHIP/(1-pct)
      // gross before the FoxKit bar may stop pushing, the bridge may claim
      // "closes it", or this band takes over. Manually-typed checkout codes
      // stay invisible here — same accepted residual as the D-119 raise.
      // ceil, not round: at Math.round(10000/0.75)=13333 gross the net can
      // land $99.99 by per-line discount rounding — always err over the line.
      shipMilestoneCents = Math.ceil(shipMilestoneCents / (1 - codePct));
    }
    // D-159 net basis: when the cart ACTUALLY carries an attached discount
    // (net < gross — cookie code, scoped JOINALA/FAM50/WEARALA-set, automatic,
    // or order-level), the summed final_line_price IS the exact number the
    // checkout rate condition and the tier3-gift Function evaluate. Measure
    // net against the UN-RAISED net goals — no /(1-pct) model needed, any
    // discount shape covered, zero map maintenance. The D-151 ceil-raise path
    // above stays as the fallback for cookie codes the cart has not attached
    // yet (set-but-unattached window) — conservative over-ask, never under.
    var netBasis = qualifyingNet < qualifying;
    var effQualifying = qualifying;
    var effShipQualifying = shipQualifying;
    if (netBasis) {
      thresholdCents = convertible ? Math.round(THRESHOLD_CENTS * rate) : Infinity;
      shipMilestoneCents = shipGoalNetCents;
      effQualifying = qualifyingNet;
      effShipQualifying = shipQualifyingNet;
      if (codePct > 0 && codePct < 1) {
        // Dual gate (D-159 panel, lens A M3): a known cookie code can still
        // be UNattached while a DIFFERENT discount produced netBasis — the
        // code's cut would land at checkout on top of the net measured here.
        // Conservative measure: min(cart net, floor(gross × (1−pct))). When
        // the attached discount IS the code (the normal case) the modeled
        // term equals the net sum on the whole-dollar grid — a no-op; floor
        // mirrors the D-151 ceil-raise boundary exactly (never under-gates).
        effQualifying = Math.min(qualifyingNet, Math.floor(qualifying * (1 - codePct)));
        effShipQualifying = Math.min(shipQualifyingNet, Math.floor(shipQualifying * (1 - codePct)));
      }
    }
    // D-249 (2026-10-11): a discountable-only code (ALA25 shape) cuts only the
    // lines it reaches. Both paths above model it against the WHOLE cart, so a
    // cart holding clearance AeroKnit (or a gift card) was asked for more than
    // checkout needs — e.g. 4 × $30 AeroKnit under an ALA25 cookie read "$13.34
    // more" on a cart that already ships free. When any counted line is out of
    // the code's reach, measure net directly: gross minus the code's cut on the
    // reached lines (ceil — never under-gate), against the un-raised net goals,
    // still capped by the cart's own net. Carts the code fully reaches are
    // untouched (the paths above stay exact for them).
    // Review F1: only with a trustworthy handle list — empty (collection gone, Liquid failed) or at Liquid's
    // 50-product cap, "unreached" can't be told from "missing", so keep the whole-cart model (over-asks).
    var dHandles = (window.ALA_DISCOUNT_CONFIG && window.ALA_DISCOUNT_CONFIG.discountableHandles) || [];
    if (codePct > 0 && codePct < 1 && convertible && dHandles.length > 0 && dHandles.length < 50) {
      var reached = 0, shipReached = 0;
      countedLines.forEach(function (l) {
        if (codeReachesHandle(codeInfo.code, l.handle)) {
          reached += l.gross;
          if (l.ship) shipReached += l.gross;
        }
      });
      if (reached < qualifying || shipReached < shipQualifying) {
        thresholdCents = Math.round(THRESHOLD_CENTS * rate);
        shipMilestoneCents = shipGoalNetCents;
        effQualifying = Math.min(qualifyingNet, qualifying - Math.ceil(reached * codePct));
        effShipQualifying = Math.min(shipQualifyingNet, shipQualifying - Math.ceil(shipReached * codePct));
        netBasis = true;
      }
    }
    return {
      currency: currency,
      convertible: convertible,
      thresholdCents: thresholdCents,
      shipMilestoneCents: shipMilestoneCents,
      shipGoalNetCents: shipGoalNetCents,
      shipQualifying: effShipQualifying,
      shipQualifyingGross: shipQualifying,
      codePct: codePct,
      codeName: codeInfo.code,
      qualifying: effQualifying,
      qualifyingGross: qualifying,
      netBasis: netBasis,
      giftLines: giftLines,
      giftUnits: giftUnits,
      giftItem: giftLines.length ? giftLines[0] : null,
      paidItemCount: paidItemCount,
      unlocked: convertible && effQualifying >= thresholdCents,
    };
  }

  // --------- rendering ---------

  function show(el, on) { if (el) el.hidden = !on; }

  // D-149: hide/show any FoxKit cart-goal bar (today it renders only in the
  // drawer; the body-class scope is future-proofing) via one
  // body class — CSS lives in ala-tier3-gift.liquid. Fail-safe: if this JS
  // never runs, the class is absent and FoxKit renders normally.
  function setGoalBarHidden(on) {
    try { document.body.classList.toggle('ala-hide-cartgoal', !!on); } catch (e) { /* no-op */ }
  }

  // D-151: keep the FoxKit bar's copy truthful for known-code holders. FoxKit
  // measures the GROSS cart against its own $100 goal, but checkout grants the
  // $0 Standard rate on the POST-discount subtotal — so for a code-holder its
  // number under-states the need and its "unlocked" celebration fires early
  // (ALA25: $33.34 early). Rewrite the copy with the remaining NET dollars —
  // the same denomination as every discount-aware price on the site —
  // computed from our own state, never parsed from FoxKit's number. No-code
  // path: native FoxKit untouched. The motivational template mirrors the
  // FoxKit dashboard string; if that is reworded in the dashboard, update the
  // template below (see changelog D-151).
  // D-154: one truthful writer for the FoxKit title. remainingCents <= 0
  // writes the celebration (goal met); otherwise the motivational line —
  // number-swap when FoxKit's own copy holds the amount, full line otherwise.
  // Copy templates mirror the FoxKit dashboard strings (see D-151 note).
  function goalTitleWrite(el, remainingCents, currency) {
    try {
      if (remainingCents <= 0) {
        el.innerHTML = '\u2728 You unlocked <strong>FREE U.S. shipping</strong>';
        return;
      }
      var displayCents = Math.ceil(remainingCents / 100) * 100;
      var moneyStr = money(displayCents, currency);
      var strong = el.querySelector('strong');
      if (strong && /\d/.test(strong.textContent || '')) {
        strong.textContent = moneyStr;
      } else {
        el.innerHTML = 'Buy <strong>' + moneyStr + '</strong> more to enjoy <strong>FREE U.S. Shipping</strong>';
      }
    } catch (e) { /* display-only */ }
  }

  function syncGoalBarTitle(st) {
    try {
      var titles = document.querySelectorAll('.foxkit-cartgoal__title');
      if (!titles.length) return;
      var pct = (st && st.codePct) || 0;
      // Active when a known code skews FoxKit's math (pct) OR when
      // non-shippable lines (gift cards) inflate FoxKit's own measure —
      // D-152 M1, live-confirmed: native "You unlocked" standing on a
      // no-code $100-GC + $38-top cart. pct=0 keeps (1-pct)=1: the ask
      // becomes goal - shipQualifying, exactly the shippable truth.
      // D-159: netBasis also activates — FoxKit measures GROSS, so any
      // cart-attached discount (scoped/automatic/unknown) skews its number
      // even when no known cookie pct is present.
      var active = !!(st && st.convertible && ((pct > 0 && pct < 1) || st.netBasis || st.shipQualifying < st.qualifying));
      for (var i = 0; i < titles.length; i++) {
        var el = titles[i];
        if (!active) {
          // D-154 (panel C-1): never replay a stored snapshot — it can be
          // older than FoxKit's fresh repaint and stand wrong. On leaving the
          // active state, write the COMPUTED truth once (no-code truth = the
          // same gross math FoxKit itself uses), unstamp, and let FoxKit own
          // the node again.
          if (el.hasAttribute('data-ala-goal-fix')) {
            el.removeAttribute('data-ala-goal-fix');
            el.removeAttribute('data-ala-goal-orig');
            if (st && st.convertible) {
              var grossRemaining = Math.max(0, st.shipGoalNetCents - st.shipQualifying);
              goalTitleWrite(el, grossRemaining, st.currency);
            }
          }
          continue;
        }
        // Remaining measured against the NET goal directly (not the ceiled
        // milestone) so clean states show the clean number, then ceil to a
        // whole dollar for display (Trevor 2026-08-19): $75 net -> "$25",
        // $46.50 net -> "$54". Over-ask only, never under.
        // D-159: in netBasis, st.shipQualifying IS already the net sum from
        // the cart — never multiply by (1-pct) again (double-discount).
        var effShipNet = st.netBasis ? st.shipQualifying : Math.round(st.shipQualifying * (1 - pct));
        var netRemaining = Math.max(0, st.shipGoalNetCents - effShipNet);
        if (netRemaining <= 0) {
          // Net goal met. D-154 (panel C-1): write the celebration truth
          // directly — replaying the stored snapshot could overwrite FoxKit's
          // fresh repaint with an ancient motivational line (its repaint IS
          // our observer trigger, so we always write after it).
          if (el.hasAttribute('data-ala-goal-fix')) {
            el.removeAttribute('data-ala-goal-fix');
            el.removeAttribute('data-ala-goal-orig');
            goalTitleWrite(el, 0, st.currency);
          }
          continue;
        }
        var displayCents = Math.ceil(netRemaining / 100) * 100;
        var stamp = String(displayCents);
        var moneyStr = money(displayCents, st.currency);
        // Stamp alone isn't proof — FoxKit can repaint the title's TEXT in
        // place without replacing the node (panel M3). Skip only while our
        // amount is still actually on screen.
        if (el.getAttribute('data-ala-goal-fix') === stamp && (el.textContent || '').indexOf(moneyStr) !== -1) continue;
        el.setAttribute('data-ala-goal-fix', stamp);
        goalTitleWrite(el, netRemaining, st.currency);
      }
    } catch (e) { /* display-only — never break the band */ }
  }

  // A36: the ladder's free-shipping step is US-only (rate table + copy).
  function isUSShopper(st) {
    try {
      var c = window.Shopify && window.Shopify.country;
      if (c) return c === 'US';
    } catch (e) { /* swallow */ }
    return !!st && st.currency === 'USD';
  }

  function renderRoot(root, st) {
    var progress = root.querySelector('[data-tier3-progress]');
    var picker = root.querySelector('[data-tier3-picker]');
    var confirmed = root.querySelector('[data-tier3-confirmed]');

    // No paid items (or product data unavailable): keep the whole band hidden.
    if (!st || !st.convertible || st.paidItemCount === 0 || (!productData && !st.giftItem)) {
      root.hidden = true;
      setGoalBarHidden(false);
      syncGoalBarTitle(st);
      return;
    }
    root.hidden = false;

    if (st.giftItem) {
      setGoalBarHidden(true);
      show(progress, false); show(picker, false); show(confirmed, true);
      var chosen = confirmed.querySelector('[data-tier3-chosen]');
      if (chosen) chosen.textContent = st.giftItem.variant_title || '';
      return;
    }

    if (!st.unlocked) {
      // A36 ladder (2026-10-06, Vix review; Trevor: "Existing 2 steps first"):
      // US shoppers see ONE bar with both milestones (free ship -> free
      // CloudSoft) from the first item, replacing the FoxKit bar (still one
      // module, so D-149's calm-down holds). Non-US carts keep the D-149
      // one-milestone path exactly (the free-US-shipping step does not apply).
      var ladder = isUSShopper(st);
      var shipDone = st.shipQualifying >= st.shipMilestoneCents;
      // One-milestone rule: free shipping first. Under $100 SHIPPABLE
      // qualifying (D-152), the band stays hidden and the FoxKit bar talks.
      if (!ladder && !shipDone) {
        root.hidden = true;
        setGoalBarHidden(false);
        syncGoalBarTitle(st);
        return;
      }
      setGoalBarHidden(true);
      show(confirmed, false); show(picker, false); show(progress, true);
      var txt = progress.querySelector('[data-tier3-progress-text]');
      var bar = progress.querySelector('[data-tier3-bar]');
      var away = st.thresholdCents - st.qualifying;
      var thumb = progress.querySelector('[data-tier3-progress-thumb]');
      if (thumb && productData && productData.imgByColor) {
        var firstImg = productData.imgByColor[productData.colors[0]];
        if (firstImg) {
          if (!thumb.src) thumb.src = firstImg + (firstImg.indexOf('?') === -1 ? '?' : '&') + 'width=96';
          thumb.hidden = false;
        }
      }
      if (txt) {
        // Whole-dollar display rule (Trevor 2026-08-19): remaining amounts
        // ceil to clean dollars, over-ask only. Net-basis sums carry real
        // cents; gross sums on the whole-dollar grid are unaffected. The bar
        // width below keeps the raw cents (drift-free).
        var awayDisplay = Math.ceil(away / 100) * 100;
        if (ladder && !shipDone) {
          var shipAwayDisplay = Math.ceil((st.shipMilestoneCents - st.shipQualifying) / 100) * 100;
          txt.innerHTML = 'You’re <strong>' + money(shipAwayDisplay, st.currency) + '</strong> away from ' +
            '<strong>free U.S. shipping</strong>, then a <strong>free CloudSoft Short Sleeve</strong>';
        } else {
          txt.innerHTML = (ladder ? '&#10003; Free U.S. shipping unlocked. ' : '') +
            'You’re <strong>' + money(awayDisplay, st.currency) + '</strong> away from a ' +
            '<strong>free CloudSoft Short Sleeve</strong> ($38 value)';
        }
      }
      if (bar) bar.style.width = Math.min(100, Math.round(st.qualifying / st.thresholdCents * 100)) + '%';
      var ladderEl = progress.querySelector('[data-tier3-ladder]');
      if (ladderEl) {
        ladderEl.hidden = !ladder;
        var mark = ladderEl.querySelector('[data-tier3-mark]');
        var pos = Math.min(100, Math.max(0, st.shipMilestoneCents / st.thresholdCents * 100));
        ladderEl.style.setProperty('--ala-ship-pos', pos.toFixed(2) + '%');
        if (mark) mark.classList.toggle('is-done', shipDone);
      }
      return;
    }

    // Unlocked, no gift yet: picker
    setGoalBarHidden(true);
    show(confirmed, false); show(progress, false); show(picker, true);
    populatePicker(root);
  }

  function populatePicker(root) {
    if (!productData) return;
    var colorSel = root.querySelector('[data-tier3-color]');
    var sizeSel = root.querySelector('[data-tier3-size]');
    if (!colorSel || !sizeSel) return;

    if (!colorSel.options.length) {
      productData.colors.forEach(function (c) {
        if (!productData.byColor[c].some(function (v) { return v.available; })) return;
        var o = document.createElement('option');
        o.value = c; o.textContent = c;
        colorSel.appendChild(o);
      });
    }
    syncSizes(root);
    applyCartSize(root);
    syncPreview(root);
  }

  // A37 (2026-10-06, found in Trevor's iPhone test): the free-gift size defaulted to the first size (XS) even for an
  // all-L cart, so one tap on "Add my free CloudSoft" added an XS. Default it to the cart's size (the bridge's rule:
  // newest line with a size) until the shopper changes the gift's size themselves; their pick is kept in a page-level
  // variable because cart updates re-render the drawer (a fresh picker element).
  var giftSizePick = null;
  function applyCartSize(root) {
    if (!root) return;
    var sizeSel = root.querySelector('[data-tier3-size]');
    if (!sizeSel) return;
    function exact(w) {
      for (var i = 0; i < sizeSel.options.length; i++) if (sizeSel.options[i].textContent === w) return i;
      return -1;
    }
    // The gift is cut XS–L: an XL cart gets the nearest offered size at or below (L), never the first option (XS).
    function nearest(w) {
      var k = BRIDGE_SIZES.indexOf(w);
      for (var j = k; j >= 0; j--) { var i = exact(BRIDGE_SIZES[j]); if (i !== -1) return i; }
      return -1;
    }
    var cartSize = bridgeInferSize(lastCart);
    var order = [[giftSizePick, exact], [cartSize, exact], [cartSize, nearest], [giftSizePick, nearest]];
    for (var t = 0; t < order.length; t++) {
      if (!order[t][0]) continue;
      var idx = order[t][1](order[t][0]);
      if (idx !== -1) { sizeSel.selectedIndex = idx; return; }
    }
  }

  // Shopify CDN width param keeps the thumb payload tiny (~5-10 KB).
  function syncPreview(root) {
    var img = root.querySelector('[data-tier3-preview]');
    var wrap = root.querySelector('[data-tier3-thumbwrap]');
    var colorSel = root.querySelector('[data-tier3-color]');
    if (!img || !colorSel || !productData || !productData.imgByColor) return;
    var src = productData.imgByColor[colorSel.value];
    if (!src) { if (wrap) wrap.hidden = true; else img.hidden = true; return; }
    img.src = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=120';
    try {
      var hoverOk = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      img.title = hoverOk ? 'Hover to enlarge' : 'Tap to enlarge';
    } catch (e) { /* swallow */ }
    if (wrap) wrap.hidden = false; else img.hidden = false;
  }

  function syncSizes(root) {
    var colorSel = root.querySelector('[data-tier3-color]');
    var sizeSel = root.querySelector('[data-tier3-size]');
    if (!colorSel || !sizeSel || !productData) return;
    var prev = sizeSel.value;
    sizeSel.innerHTML = '';
    (productData.byColor[colorSel.value] || []).forEach(function (v) {
      if (!v.available) return;
      var o = document.createElement('option');
      o.value = String(v.id); o.textContent = v.size;
      sizeSel.appendChild(o);
    });
    // restore same size across color switches when possible
    for (var i = 0; i < sizeSel.options.length; i++) {
      var opt = sizeSel.options[i];
      var match = (productData.byColor[colorSel.value] || []).some(function (v) {
        return String(v.id) === opt.value && sizeAgainst(prev, v);
      });
      if (match) { sizeSel.selectedIndex = i; break; }
    }
  }

  function sizeAgainst(prevVariantId, v) {
    if (!prevVariantId || !productData) return false;
    var prevSize = null;
    Object.keys(productData.byColor).some(function (c) {
      return productData.byColor[c].some(function (pv) {
        if (String(pv.id) === String(prevVariantId)) { prevSize = pv.size; return true; }
        return false;
      });
    });
    return prevSize != null && prevSize === v.size;
  }

  function renderAll() {
    document.querySelectorAll('[data-ala-tier3]').forEach(function (root) {
      renderRoot(root, lastState);
    });
    tagGiftRow();
    renderBridge();
  }

  // Row tagging: data-index is EMPTY on the /cart page render, so the D-052
  // index bridge is unusable here. The $0 gift product's id is unique to gift
  // lines (paid CloudSofts are a different product), so data-product-id alone
  // identifies the row.
  function tagGiftRow() {
    document.querySelectorAll('.ala-tier3-line').forEach(function (el) {
      el.classList.remove('ala-tier3-line');
    });
    if (!lastState || !lastState.giftItem) return;
    document.querySelectorAll('[data-cart-item][data-product-id="' + GIFT_PRODUCT_ID + '"]').forEach(function (el) {
      el.classList.add('ala-tier3-line');
    });
  }

  // --------- cart mutations ---------

  function dispatchCartRefresh() {
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
    } catch (e) { /* swallow */ }
    if (location.pathname === '/cart') {
      setTimeout(function () { location.reload(); }, 700);
    }
  }

  function addGift(variantId, root) {
    if (actionInFlight) return;
    actionInFlight = true;
    var btn = root.querySelector('[data-tier3-add]');
    var err = root.querySelector('[data-tier3-err]');
    if (btn) btn.setAttribute('data-busy', '1');
    show(err, false);
    var props = {};
    props[GIFT_PROP] = 'true';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1, properties: props }] }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed ' + r.status);
        return refresh();
      })
      .then(dispatchCartRefresh)
      .catch(function () {
        if (err) { err.textContent = 'Couldn’t add your gift — try again.'; show(err, true); }
      })
      .then(function () {
        actionInFlight = false;
        if (btn) btn.removeAttribute('data-busy');
      });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    });
  }

  // Enforcement pass on every refresh:
  //  - cart dropped below threshold -> remove all gift lines
  //  - more than 1 gift unit (qty bump OR line split — Shopify re-keys lines
  //    when discount allocations change, so a stale-key change can leave a
  //    paid twin line) -> wipe ALL gift lines, re-add exactly one qty-1 line.
  // NOTE (D-154, panel C-3): each enforce cycle re-fetches once on entry; a
  // line re-keyed mid-loop 404s harmlessly and the next cycle converges.
  function removeAllGiftLines() {
    return fetchCart().then(function (c) {
      var gifts = (c.items || []).filter(isGiftItem);
      var p = Promise.resolve();
      gifts.forEach(function (g) {
        p = p.then(function () { return changeLine(g.key, 0); })
             .then(function () { return fetchCart(); })
             .catch(function () { /* continue */ });
      });
      return p;
    });
  }

  function enforce(st) {
    if (!st.giftItem || actionInFlight) return Promise.resolve(false);
    if (st.convertible && !st.unlocked) {
      actionInFlight = true;
      return removeAllGiftLines().then(function () {
        actionInFlight = false;
        dispatchCartRefresh();
        return true;
      }, function () { actionInFlight = false; return false; });
    }
    if (st.giftUnits > 1) {
      var variantId = st.giftItem.variant_id;
      actionInFlight = true;
      return removeAllGiftLines()
        .then(function () {
          var props = {};
          props[GIFT_PROP] = 'true';
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: props }] }),
          });
        })
        .then(function () {
          actionInFlight = false;
          dispatchCartRefresh();
          return true;
        }, function () { actionInFlight = false; return false; });
    }
    return Promise.resolve(false);
  }

  // ---------- D-150 bridge-rec row (spec: reports/2026-08-19-bridge-rec-spec.md) ----------
  // One card that CLOSES the visible milestone gap. Rides lastState/lastCart;
  // renders nothing unless a milestone module is in a gap state and an
  // in-stock closer exists. Availability booleans only. Plain /cart/add.js.

  /*BRIDGE-PURE-START*/
  var BRIDGE_SIZES = ['XS', 'S', 'M', 'L', 'XL'];
  var BRIDGE_CFG = {
    display: {
      'cloudsoft-short-sleeve-underscrub': 'CloudSoft Short Sleeve',
      'aeroknit-seamless-long-sleeve-underscrub': 'AeroKnit Seamless',
      'beige-leopard-flexform-compression-underscrub': 'Beige Leopard FlexForm',
      'silkseam-underscrub': 'SilkSeam Soft'
    },
    hero: {
      'cloudsoft-short-sleeve-underscrub': 'Black',
      'aeroknit-seamless-long-sleeve-underscrub': 'Black'
    },
    singleColor: ['beige-leopard-flexform-compression-underscrub', 'silkseam-underscrub'],
    // Gap bands (cents): first eligible band is the PREFERENCE (cheapest
    // adequate closer); D-155 (Trevor 2026-08-20): when a band yields no
    // size-qualified candidate, CASCADE to the pricier bands — any pricier
    // product crosses by definition, and a higher-priced rec beats silence.
    // Scrunchie removed from the pool (panel: selling $15 scrunchies beside the
    // free-scrunchie claim line is a trust hit); CloudSoft covers small gaps
    // (overshoot accepted, decision Q2). Bands A+B merged accordingly.
    bands: [
      { max: 3800, list: ['cloudsoft-short-sleeve-underscrub', 'aeroknit-seamless-long-sleeve-underscrub'] },
      { max: 6200, list: ['beige-leopard-flexform-compression-underscrub', 'silkseam-underscrub'] },
      { max: 6400, list: ['silkseam-underscrub'] }
    ]
  };

  function bridgeSizeOf(item) {
    var ows = (item && item.options_with_values) || [];
    for (var i = 0; i < ows.length; i++) {
      if (String(ows[i].name || '').toLowerCase() === 'size' &&
          BRIDGE_SIZES.indexOf(ows[i].value) !== -1) return ows[i].value;
    }
    return null;
  }

  // Recency-first: /cart.js items[0] is the newest line (probe-proven).
  // $0 tier3 gift lines count — that size was actively chosen.
  function bridgeInferSize(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var s = bridgeSizeOf(items[i]);
      if (s) return s;
    }
    return null;
  }

  function bridgeOptIdx(prod, name) {
    var names = (prod && prod.optnames) || [];
    for (var i = 0; i < names.length; i++) {
      if (String(names[i]).toLowerCase() === name) return i;
    }
    return -1;
  }

  function bridgeSizesOf(prod) {
    var si = bridgeOptIdx(prod, 'size');
    if (si === -1) return [];
    var seen = {};
    (prod.variants || []).forEach(function (v) { seen[v.o[si]] = true; });
    return BRIDGE_SIZES.filter(function (s) { return seen[s]; });
  }

  function bridgeColorsOf(prod) {
    var ci = bridgeOptIdx(prod, 'color');
    if (ci === -1) return [];
    var out = [], seen = {};
    (prod.variants || []).forEach(function (v) {
      var c = v.o[ci];
      if (!seen[c]) { seen[c] = true; out.push(c); }
    });
    return out;
  }

  function bridgeVariantFor(prod, color, size) {
    var ci = bridgeOptIdx(prod, 'color'), si = bridgeOptIdx(prod, 'size');
    var vs = (prod.variants || []);
    for (var i = 0; i < vs.length; i++) {
      var v = vs[i];
      if (ci !== -1 && color != null && v.o[ci] !== color) continue;
      if (si !== -1 && size != null && v.o[si] !== size) continue;
      return v;
    }
    return null;
  }

  function bridgeSizeAvail(prod, color, size) {
    var v = bridgeVariantFor(prod, color, size);
    return !!(v && v.a);
  }

  // Preference-ordered colorways: product-already-in-cart -> not-in-cart
  // colorways first (hero leading), else cart-matched colors first, then hero,
  // then the rest in product order. bridgeDefaultColor = first of this order;
  // D-153 size-gated picks walk the SAME order for the first colorway that
  // carries the shopper's size.
  function bridgeColorOrder(prod, handle, cartColors, cartHandles) {
    var colors = bridgeColorsOf(prod);
    if (!colors.length) return [];
    var order = [];
    var push = function (c) { if (c != null && colors.indexOf(c) !== -1 && order.indexOf(c) === -1) order.push(c); };
    var hero = BRIDGE_CFG.hero[handle];
    var inCart = (cartHandles || []).indexOf(handle) !== -1;
    if (inCart) {
      var notInCart = colors.filter(function (c) { return (cartColors || []).indexOf(c) === -1; });
      if (hero && notInCart.indexOf(hero) !== -1) push(hero);
      notInCart.forEach(push);
    } else {
      (cartColors || []).forEach(push);
      push(hero);
    }
    colors.forEach(push);
    return order;
  }

  // Default color: manual (if valid) -> first of the preference order.
  // (§C duplicate rule, multi-color arm, is folded into the order.)
  function bridgeDefaultColor(prod, handle, cartColors, manualColor, cartHandles) {
    var colors = bridgeColorsOf(prod);
    if (!colors.length) return null;
    if (manualColor && colors.indexOf(manualColor) !== -1) return manualColor;
    var order = bridgeColorOrder(prod, handle, cartColors, cartHandles);
    return order.length ? order[0] : colors[0];
  }

  // Eligibility vs the CHOSEN color: score 2 = shopper's size available
  // (preselect) · 1 = no size inference and something available · 0 = out.
  // D-153 (Trevor 2026-08-20): when the cart tells us their size, that size is
  // a HARD gate — we never recommend a product/colorway without it (the pick
  // walks other colorways first; adjacent-size fallback is gone for good).
  function bridgeScore(prod, handle, inferred, cartHandles, gapCents, color) {
    if (!prod || prod.price < gapCents) return 0;                 // closer rule
    if (BRIDGE_CFG.singleColor.indexOf(handle) !== -1 &&
        cartHandles.indexOf(handle) !== -1) return 0;             // duplicate rule
    var sizes = bridgeSizesOf(prod);
    if (!sizes.length) {                                          // one-size product
      var anyV = (prod.variants || []).some(function (v) { return v.a; });
      return anyV ? 2 : 0;
    }
    if (!inferred) {
      var anyS = sizes.some(function (s) { return bridgeSizeAvail(prod, color, s); });
      return anyS ? 1 : 0;
    }
    return bridgeSizeAvail(prod, color, inferred) ? 2 : 0;
  }

  // st -> {zone, gapCents} | null. Mirrors renderRoot's one-milestone zones.
  // Gift-zone bridging DISABLED (Trevor 2026-08-19): in-cart gift pushing pulls
  // shoppers back into browsing mode at the moment they should be checking out.
  // The gift-unlock path moves to post-purchase (research in flight). Flip
  // BRIDGE_GIFT_ZONE_ENABLED to restore the old behavior.
  var BRIDGE_GIFT_ZONE_ENABLED = false;
  function bridgeGap(st) {
    if (!st || !st.convertible || st.paidItemCount === 0 || st.giftItem || st.unlocked) return null;
    if (st.shipQualifying < st.shipMilestoneCents) {
      return { zone: 'ship', gapCents: st.shipMilestoneCents - st.shipQualifying };
    }
    if (BRIDGE_GIFT_ZONE_ENABLED && st.qualifying < st.thresholdCents) {
      return { zone: 'gift', gapCents: st.thresholdCents - st.qualifying };
    }
    return null;
  }

  function bridgePick(pool, st, cart, manualColor) {
    var gap = bridgeGap(st);
    if (!gap) return null;
    // D-159: bands and the closer rule compare GROSS catalog prices. In net
    // basis with a known flat pct the truthful net gap must be re-grossed
    // (/(1-pct), ceil) so the crossing guarantee stays exact: a $38 top nets
    // $28.50 under ALA25 — it closes a net gap of $28.50, not $38. With an
    // unknown-shape discount (scoped/automatic; pct=0) the net gap is used
    // as-is: a catalog candidate outside the code's scope contributes its
    // full price. Residual: a scoped code that ALSO covers the candidate can
    // under-close once — the milestone gate itself stays net-true and the
    // card simply re-renders with the small remainder.
    var bandGapCents = (st.netBasis && st.codePct > 0 && st.codePct < 1)
      ? Math.ceil(gap.gapCents / (1 - st.codePct))
      : gap.gapCents;
    var bandStart = -1;
    for (var i = 0; i < BRIDGE_CFG.bands.length; i++) {
      if (bandGapCents <= BRIDGE_CFG.bands[i].max) { bandStart = i; break; }
    }
    if (bandStart === -1) return null;                            // gap > $64: nothing closes
    var items = (cart && cart.items) || [];
    var cartHandles = items.map(function (it) { return it.handle; });
    var cartColors = [];
    items.forEach(function (it) {
      var ows = it.options_with_values || [];
      for (var i2 = 0; i2 < ows.length; i2++) {
        if (String(ows[i2].name || '').toLowerCase() === 'color' &&
            cartColors.indexOf(ows[i2].value) === -1) cartColors.push(ows[i2].value);
      }
    });
    var inferred = bridgeInferSize(cart);
    var best = null;
    // D-155: walk bands from the price-fit one upward; stop at the first band
    // that yields any qualified candidate (price preference intact, silence
    // only when NOTHING crossing carries their size).
    for (var bi = bandStart; bi < BRIDGE_CFG.bands.length && !best; bi++) {
    var band = BRIDGE_CFG.bands[bi];
    for (var k = 0; k < band.list.length; k++) {
      var h = band.list[k];
      var prod = pool[h];
      if (!prod) continue;
      var color;
      if (inferred && bridgeSizesOf(prod).length) {
        // D-153: walk the colorway preference order to the first one carrying
        // the shopper's size — a different COLORWAY beats a different size,
        // and no colorway with their size means this candidate is skipped.
        var order = bridgeColorOrder(prod, h, cartColors, cartHandles);
        if (!order.length) {
          if (!bridgeSizeAvail(prod, null, inferred)) continue;
          color = null;
        } else {
          color = null;
          var prodInCart = cartHandles.indexOf(h) !== -1;
          for (var c2 = 0; c2 < order.length; c2++) {
            // D-153 ladder (reviewer M2): for a product already in the cart,
            // never auto-rec a colorway they already own — different colorway,
            // then different product, then nothing.
            if (prodInCart && cartColors.indexOf(order[c2]) !== -1) continue;
            if (bridgeSizeAvail(prod, order[c2], inferred)) { color = order[c2]; break; }
          }
          if (!color) continue;
        }
      } else {
        color = bridgeDefaultColor(prod, h, cartColors, null, cartHandles);
      }
      var score = bridgeScore(prod, h, inferred, cartHandles, bandGapCents, color);
      if (score === 0) continue;
      if (!best || score > best.score) {
        best = { handle: h, prod: prod, color: color, score: score, inferred: inferred, zone: gap.zone, gapCents: bandGapCents, cartColors: cartColors, cartHandles: cartHandles };
        if (score === 2 && k === 0) break;                        // band order wins on ties
      }
    }
    }
    if (best && manualColor && bridgeColorsOf(best.prod).indexOf(manualColor) !== -1) {
      // Manual colorway applies to the WINNING product's display only — it can
      // restyle the card, never change which product is recommended. D-153:
      // a stale manual color from a DIFFERENT product no longer resolves to a
      // default that clobbers the size-valid walk (reviewer M1) — foreign
      // colors are simply ignored.
      best.color = manualColor;
    }
    return best;
  }
  /*BRIDGE-PURE-END*/

  var BRIDGE_STATE = { suppressed: false, manualSize: null, manualColor: null, shownKey: null, busy: false };

  // D-150 rollout gate (spec §B): dark until ALA_BRIDGE_ENABLED flips true in
  // the snippet; ?ala-bridge-preview (sessionStorage-sticky) overrides — the
  // exact tier3 preview precedent.
  function bridgeStickPreview() {
    // Hoisted from bridgeEnabled (correctness-lane advisory): runs at init on
    // EVERY page, so ?ala-bridge-preview sticks even when the drawer/root
    // doesn't exist yet (e.g. landing on the homepage with an empty cart).
    try {
      if (window.location.search.indexOf('ala-bridge-preview') !== -1) {
        sessionStorage.setItem('ala_bridge_preview', '1');
      }
    } catch (e) { /* no-op */ }
  }
  function bridgeEnabled() {
    try {
      if (sessionStorage.getItem('ala_bridge_preview') === '1') return true;
    } catch (e) { /* no-op */ }
    return window.ALA_BRIDGE_ENABLED === true;
  }

  function bridgeTrack(event, payload) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: event }, payload || {}));
    } catch (e) { /* no-op */ }
  }

  function bridgePoolData() {
    var el = document.querySelector('script[data-bridge-pool]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function bridgeRoot() { return document.querySelector('[data-ala-bridge]'); }

  function renderBridge() {
    var root = bridgeRoot();
    if (!root) return;
    if (!bridgeEnabled()) { root.hidden = true; return; }
    if (BRIDGE_STATE.suppressed || !lastState || !lastCart) { root.hidden = true; return; }
    var pool = bridgePoolData();
    if (!pool) { root.hidden = true; return; }
    var pick = bridgePick(pool, lastState, lastCart, BRIDGE_STATE.manualColor);
    if (!pick) { root.hidden = true; return; }
    // Gift-band closer only speaks when the gift milestone band itself can
    // render (productData fetch succeeded) — never a voice with no milestone.
    if (pick.zone === 'gift' && !productData) { root.hidden = true; return; }

    var prod = pick.prod, handle = pick.handle;
    var sizes = bridgeSizesOf(prod);
    var oneSize = sizes.length === 0;
    var chosen = null;
    if (oneSize) {
      chosen = null; // variant resolved directly
    } else if (BRIDGE_STATE.manualSize && bridgeSizeAvail(prod, pick.color, BRIDGE_STATE.manualSize)) {
      chosen = BRIDGE_STATE.manualSize;
    } else if (pick.inferred && bridgeSizeAvail(prod, pick.color, pick.inferred)) {
      chosen = pick.inferred;
    }

    var q = function (sel) { return root.querySelector(sel); };
    var headingEl = q('[data-bridge-heading]');
    if (headingEl) {
      headingEl.textContent = (pick.zone === 'gift' && handle === 'cloudsoft-short-sleeve-underscrub')
        ? 'Add one, unlock a second free \ud83e\udd0d'
        : 'This closes it \ud83e\udd0d';
    }
    var titleEl = q('[data-bridge-title]');
    if (titleEl) titleEl.textContent = BRIDGE_CFG.display[handle] || handle;
    // D-159: known sitewide pct holders pay the discounted price at checkout
    // and every other price on the site already shows it (discount-aware
    // engine) — the chip AND the Add label speak the same denomination.
    // Scoped/unknown codes (pct=0) keep the gross catalog price: we can't
    // know their scope. D-248: neither does a discountable-only code (ALA25)
    // on a product outside `discountable` (AeroKnit clearance) — checkout
    // charges its full price, so the chip shows it.
    var chipCents = (lastState.codePct > 0 && lastState.codePct < 1 && codeReachesHandle(lastState.codeName, handle))
      ? Math.round(prod.price * (1 - lastState.codePct))
      : prod.price;
    var priceEl = q('[data-bridge-price]');
    if (priceEl) priceEl.textContent = money(chipCents, lastState.currency);

    var colors = bridgeColorsOf(prod);
    var multi = colors.length > 1;
    var colorline = q('[data-bridge-colorline]');
    if (colorline) colorline.hidden = !multi;
    var chosenVariant = oneSize
      ? (prod.variants || []).filter(function (v) { return v.a; })[0] || prod.variants[0]
      : bridgeVariantFor(prod, pick.color, chosen || sizes[0]);
    var thumb = q('[data-bridge-thumb]');
    if (thumb && chosenVariant && chosenVariant.img) { thumb.src = chosenVariant.img; thumb.alt = BRIDGE_CFG.display[handle] || ''; thumb.hidden = false; }
    if (multi) {
      var dot = q('[data-bridge-swatchdot]');
      var cv = bridgeVariantFor(prod, pick.color, null);
      if (dot && cv && cv.img) { dot.src = cv.img; dot.alt = pick.color; }
      var cn = q('[data-bridge-colorname]');
      if (cn) cn.textContent = pick.color;
      var sw = q('[data-bridge-swatches]');
      if (sw) {
        var swHtml = '';
        colors.forEach(function (c) {
          var v0 = bridgeVariantFor(prod, c, null);
          swHtml += '<button type="button" class="ala-bridge__swatch" data-bridge-swatch="' + c.replace(/"/g, '&quot;') + '" aria-pressed="' + (c === pick.color ? 'true' : 'false') + '" aria-label="' + c.replace(/"/g, '&quot;') + '">' + (v0 && v0.img ? '<img src="' + String(v0.img).replace(/"/g, '&quot;') + '" alt="">' : '') + '</button>';
        });
        sw.innerHTML = swHtml;
      }
    }

    var chips = q('[data-bridge-chips]');
    if (chips) {
      if (oneSize) { chips.innerHTML = ''; chips.hidden = true; }
      else {
        chips.hidden = false;
        var html = '';
        sizes.forEach(function (s) {
          var avail = bridgeSizeAvail(prod, pick.color, s);
          html += '<button type="button" class="ala-bridge__chip" data-bridge-chip="' + s + '" aria-pressed="' + (s === chosen ? 'true' : 'false') + '"' + (avail ? '' : ' disabled') + '>' + s + '</button>';
        });
        chips.innerHTML = html;
      }
    }

    var cap = q('[data-bridge-sizecaption]');
    if (cap) {
      if (oneSize) cap.textContent = 'One size';
      else if (chosen && chosen === pick.inferred && !BRIDGE_STATE.manualSize) cap.textContent = 'Size ' + chosen + ' — matched to your cart';
      else if (chosen) cap.textContent = 'Size ' + chosen;
      else cap.textContent = 'Pick a size';
    }

    var add = q('[data-bridge-add]');
    var addVariant = oneSize ? chosenVariant : (chosen ? bridgeVariantFor(prod, pick.color, chosen) : null);
    if (add) {
      if (addVariant && addVariant.a) {
        add.disabled = false;
        add.textContent = 'Add — ' + money(chipCents, lastState.currency);
        add.setAttribute('data-bridge-variant', addVariant.id);
      } else {
        add.disabled = true;
        add.textContent = 'Add';
        add.removeAttribute('data-bridge-variant');
      }
    }
    var err = q('[data-bridge-err]');
    if (err) { err.hidden = true; err.textContent = ''; }
    root.hidden = false;

    var key = pick.zone + ':' + handle;
    var drawerEl = document.querySelector('m-cart-drawer');
    var drawerOpen = !!(drawerEl && drawerEl.classList.contains('m-cart-drawer--active'));
    if (drawerOpen && BRIDGE_STATE.shownKey !== key) {   // fire on ACTUAL visibility (aq5 denominator lesson)
      BRIDGE_STATE.shownKey = key;
      bridgeTrack('ala_bridge_shown', { zone: pick.zone, gap_cents: pick.gapCents, handle: handle });
    }
  }

  function bridgeAdd(btn) {
    var root = bridgeRoot();
    var vid = btn.getAttribute('data-bridge-variant');
    if (!vid || BRIDGE_STATE.busy || !root) return;
    BRIDGE_STATE.busy = true;
    root.setAttribute('data-busy', '');
    var prevLabel = btn.textContent;
    btn.textContent = 'Adding…';
    // 'cart-drawer,cart-count' is provably equivalent to the theme's dynamic
    // cart:grouped-sections assembly in every context the drawer exists in.
    var body = { items: [{ id: parseInt(vid, 10), quantity: 1 }], sections: 'cart-drawer,cart-count' };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed ' + r.status);
      return r.json();
    }).then(function (resp) {
      BRIDGE_STATE.busy = false;
      if (root) root.removeAttribute('data-busy'); // D-154: don't rely solely on the re-render
      btn.textContent = prevLabel;
      BRIDGE_STATE.suppressed = true;    // one rec per drawer-open
      BRIDGE_STATE.manualSize = null;
      BRIDGE_STATE.manualColor = null;
      bridgeTrack('ala_bridge_add', { variant_id: vid });
      try {
        if (window.MinimogEvents && window.MinimogTheme && MinimogTheme.pubSubEvents && resp.sections) {
          MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, { cart: resp });
        } else {
          dispatchCartRefresh();
        }
      } catch (e) { dispatchCartRefresh(); }
    }).catch(function () {
      BRIDGE_STATE.busy = false;
      if (root) root.removeAttribute('data-busy');
      btn.textContent = prevLabel;
      var err = root && root.querySelector('[data-bridge-err]');
      if (err) { err.textContent = 'That didn’t go through — please try again.'; err.hidden = false; }
    });
  }

  var bridgeBound = false;
  function bridgeInit() {
    if (bridgeBound) return;
    bridgeBound = true;
    bridgeStickPreview();
    document.addEventListener('click', function (e) {
      var t = e.target;
      var chip = t.closest && t.closest('[data-bridge-chip]');
      if (chip && !chip.disabled) {
        BRIDGE_STATE.manualSize = chip.getAttribute('data-bridge-chip');
        bridgeTrack('ala_bridge_size_change', { size: BRIDGE_STATE.manualSize });
        renderBridge();
        return;
      }
      var sw = t.closest && t.closest('[data-bridge-swatch]');
      if (sw) {
        BRIDGE_STATE.manualColor = sw.getAttribute('data-bridge-swatch');
        renderBridge();
        var swRow = document.querySelector('[data-bridge-swatches]');
        if (swRow) swRow.hidden = true;
        return;
      }
      var ch = t.closest && t.closest('[data-bridge-changecolor]');
      if (ch) {
        var row = document.querySelector('[data-bridge-swatches]');
        if (row) row.hidden = !row.hidden;
        bridgeTrack('ala_bridge_color_open', {});
        return;
      }
      var add = t.closest && t.closest('[data-bridge-add]');
      if (add) bridgeAdd(add);
    });
    // Reset the one-rec-per-open suppression when the drawer reopens.
    var drawer = document.querySelector('m-cart-drawer');
    if (drawer && 'MutationObserver' in window) {
      new MutationObserver(function () {
        if (drawer.classList.contains('m-cart-drawer--active')) {
          if (BRIDGE_STATE.suppressed) {
            BRIDGE_STATE.suppressed = false;
            BRIDGE_STATE.shownKey = null;
          }
          renderBridge();   // fires the pending shown event now that the drawer is visible
        }
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
  }

  // --------- refresh loop ---------

  var refreshGen = 0; // D-154 (panel C-2): out-of-order /cart.js responses must not render/enforce on stale snapshots
  function refresh() {
    var gen = ++refreshGen;
    return Promise.all([fetchProduct(), fetchCart()]).then(function (res) {
      if (gen !== refreshGen) return; // a newer refresh superseded this one
      var cart = res[1];
      lastState = computeState(cart);
      lastCart = cart;
      return enforce(lastState).then(function (mutated) {
        if (mutated) return fetchCart().then(function (c2) { lastState = computeState(c2); lastCart = c2; renderAll(); });
        renderAll();
      });
    }).catch(function () { /* leave last render in place */ });
  }

  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, 200);
  }

  // --------- events (document-level delegation, survives re-renders) ---------

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-tier3-add]');
    if (!btn) return;
    var root = btn.closest('[data-ala-tier3]');
    var sizeSel = root && root.querySelector('[data-tier3-size]');
    if (!sizeSel || !sizeSel.value) return;
    addGift(sizeSel.value, root);
  }, true);

  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('[data-tier3-size]')) return;
    var opt = e.target.options[e.target.selectedIndex];
    if (opt) giftSizePick = opt.textContent;
  });

  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('[data-tier3-color]')) return;
    var root = e.target.closest('[data-ala-tier3]');
    if (root) { syncSizes(root); syncPreview(root); }
  });

  ['cart:updated', 'cart:refresh', 'cart:grouped'].forEach(function (ev) {
    document.addEventListener(ev, scheduleRefresh);
  });

  // D-101: desktop hover-zoom for the free-gift cart-line image. Single
  // popover element, document-level mouseover delegation (survives drawer
  // re-renders). Positions beside the hovered image; falls back to the other
  // side when space is tight. Touch devices excluded via CSS media query.
  var zoomEl = null;
  function ensureZoomEl() {
    if (zoomEl && document.body.contains(zoomEl)) return zoomEl;
    zoomEl = document.createElement('div');
    zoomEl.id = 'ala-tier3-zoom';
    zoomEl.appendChild(document.createElement('img'));
    document.body.appendChild(zoomEl);
    return zoomEl;
  }
  // D-102 (Trevor): zoom is CART-WIDE — every line image in the drawer/cart
  // page plus the picker preview thumb. Source = the hovered image itself,
  // upscaled via the CDN width param (works for any product, no cart lookup).
  var ZOOM_TARGETS = '[data-cart-item] img, [data-tier3-preview]';
  function zoomSrcFor(imgEl) {
    var base = imgEl.currentSrc || imgEl.src || '';
    if (!base) return null;
    base = base.replace(/([?&])(width|height)=\d+&?/g, '$1').replace(/[?&]$/, '');
    return base + (base.indexOf('?') === -1 ? '?' : '&') + 'width=700';
  }
  function showZoom(imgEl) {
    var src = zoomSrcFor(imgEl);
    if (!src) return;
    var el = ensureZoomEl();
    el.querySelector('img').src = src;
    var r = imgEl.getBoundingClientRect();
    var w = Math.min(340, window.innerWidth * 0.4);
    var left = r.left - w - 16;                 // prefer left (drawer sits right)
    if (left < 8) left = Math.min(r.right + 16, window.innerWidth - w - 8);
    var top = Math.max(8, Math.min(r.top - 40, window.innerHeight - 440));
    el.style.left = left + 'px';
    el.style.top = top + 'px';
    el.setAttribute('data-on', '1');
  }
  function hideZoom() {
    if (zoomEl) zoomEl.removeAttribute('data-on');
  }
  var hoverCapable = false;
  try { hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)').matches; } catch (e) { /* swallow */ }
  if (hoverCapable) {
    document.addEventListener('mouseover', function (e) {
      var img = e.target.closest && e.target.closest(ZOOM_TARGETS);
      if (img) showZoom(img);
    });
    document.addEventListener('mouseout', function (e) {
      if (e.target.closest && e.target.closest(ZOOM_TARGETS)) hideZoom();
    });
  } else {
    // Touch: tap the PICKER THUMB to toggle the large view (line images keep
    // their native tap = link to PDP). Tap anywhere else closes it.
    document.addEventListener('click', function (e) {
      var thumb = e.target.closest && e.target.closest('[data-tier3-thumbwrap]');
      if (thumb) {
        e.preventDefault();
        var img = thumb.querySelector('img');
        if (zoomEl && zoomEl.hasAttribute('data-on')) hideZoom();
        else if (img) showZoom(img);
        return;
      }
      hideZoom();
    });
  }
  document.addEventListener('scroll', hideZoom, true);

  var observerBound = false;
  function bindObserver() {
    if (observerBound || !('MutationObserver' in window)) return;
    observerBound = true;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        // D-151a: FoxKit repaints INSIDE its title node (text/strong swapped
        // in place — the node itself is never re-inserted), which can lay its
        // native gross celebration over our truthful copy and let it STAND
        // (live-caught: "You unlocked" standing at $75 net). Any mutation
        // scoped within a title re-runs the sync; syncGoalBarTitle is
        // write-free when content already matches, so this settles in one
        // extra tick and cannot loop.
        var tgt = m.target && m.target.nodeType === 1 ? m.target : (m.target && m.target.parentElement);
        if (tgt && tgt.closest && tgt.closest('.foxkit-cartgoal__title')) {
          renderAll();
          return;
        }
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n.nodeType === 1 && (n.matches && n.matches('[data-ala-tier3],[data-ala-bridge],.foxkit-cartgoal__title,foxkit-cart-goal') || n.querySelector && n.querySelector('[data-ala-tier3],[data-ala-bridge],.foxkit-cartgoal__title,foxkit-cart-goal'))) {
            renderAll();          // instant re-render from cache
            scheduleRefresh();    // then reconcile with authoritative cart
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  function init() {
    bindObserver();
    bridgeInit();
    refresh();
    // D-154 (panel B-2): back-forward cache restores (e.g. back from
    // checkout after removing/applying a code) resurrect stale milestone
    // copy — reconcile immediately on bfcache restore.
    window.addEventListener('pageshow', function (e) { if (e && e.persisted) scheduleRefresh(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
